import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const pause = (duration) => {
  return new Promise((resolve) => setTimeout(resolve, duration));
};

const modelApi = createApi({
  reducerPath: "model",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_ENDPOINT}api/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("access-token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
    fetchFn: async (...args) => {
      await pause(1000);
      return fetch(...args);
    },
  }),
  endpoints(builder) {
    return {
      fetchModels: builder.query({
        providesTags: () => ["models"],
        query: (pagination) => {
          return {
            url: pagination
              ? `model?page=${pagination.page}&limit=${pagination.limit}&searchText=${pagination.searchText}`
              : "model?searchText=" + pagination.searchText,
            method: "GET",
          };
        },
      }),
      postModel: builder.mutation({
        invalidatesTags: () => ["models"],
        query: (model) => {
          return {
            url: "model/",
            method: model.id === 0 ? "POST" : "PUT",
            body: model,
          };
        },
      }),
      deleteModel: builder.mutation({
        invalidatesTags: () => ["models"],
        query: (id) => {
          return {
            url: `model?id=${id}`,
            method: "DELETE",
          };
        },
      }),
    };
  },
});

export const {
  useFetchModelsQuery,
  usePostModelMutation,
  useDeleteModelMutation,
} = modelApi;

export { modelApi };
